<template>
  <div class="reports-col">
    {{ label }}
    <i v-if="sortData.key === sortKey" :class="'icofont-rounded-' + (sortData.ascending ? 'up' : 'down')"></i>
  </div>
</template>

<script>
  export default {
    name: 'SortableCol',
    props: {
      label: String,
      sortKey: String,
      sortData: Object
    }
  }
</script>
